import { cn } from '~/lib/utils'

interface LoadingSpinnerProps {
  className?: string
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div
      className={cn(
        'h-6 w-6 animate-spin rounded-full border-2 border-zinc-400 border-t-transparent',
        className
      )}
    />
  )
}
